export default "__VITE_ASSET__873a9fdc__"